<template>
  <div class="cardBox">
    <head-page></head-page>

    <div class="cardBody reportPage">
      <div class="reportBox">
        <div class="title">液基细胞学检查报告单</div>
        <div class="number">
          <span>病理号:</span>
          <p>{{ detail.tbsNo }}</p>
        </div>
        <div class="about">
          <p>姓名:{{ detail.patientName }}</p>
          <p>性别:{{ detail.patientSex == 1 ? "男" : "女" }}</p>
          <p>年龄:{{ detail.patientAge }}</p>
          <p>送检单位:{{ detail.inspectionUnit }}</p>
          <p>送检日期:{{ detail.inspectionDate }}</p>
          <p>送检人:{{ detail.inspectionPerson }}</p>
        </div>
        <div class="reportTxt">
          <div class="txtBox">
            <dl>
              <dt>标本质量评估：</dt>
              <dd>
                <ul>
                  <li>
                    <label class="radioBox">
                      <input
                        v-model="detail.isSatisfied"
                        value="1"
                        type="radio"
                        @change="isSatisfied"
                      />
                      <span>满意</span>
                    </label>
                  </li>
                  <li>
                    <label class="radioBox">
                      <input
                        v-model="detail.isSatisfied"
                        value="2"
                        type="radio"
                        @change="isSatisfied"
                      />
                      <span>不满意：</span>
                    </label>
                    <div class="inBox">
                      <label class="checkBox">
                        <input
                          v-model="detail.satisfiedDescription"
                          :disabled="detail.isSatisfied == 1 ? true : false"
                          type="checkbox"
                          value="1"
                        />
                        <span>鳞状细胞缺乏</span>
                      </label>
                      <label class="checkBox">
                        <input
                          v-model="detail.satisfiedDescription"
                          :disabled="detail.isSatisfied == 1 ? true : false"
                          type="checkbox"
                          value="2"
                        />
                        <span>炎细胞、血液过多</span>
                      </label>
                      <label class="checkBox">
                        <input
                          v-model="detail.satisfiedDescription"
                          :disabled="detail.isSatisfied == 1 ? true : false"
                          type="checkbox"
                          value="3"
                        />
                        <span>无颈管细胞</span>
                      </label>
                      <label class="checkBox">
                        <input
                          v-model="detail.satisfiedDescription"
                          :disabled="detail.isSatisfied == 1 ? true : false"
                          type="checkbox"
                          value="4"
                        />
                        <span>无化生细胞</span>
                      </label>
                    </div>
                  </li>
                </ul>
              </dd>
            </dl>
            <dl>
              <dt>细胞分析：</dt>
              <dd>
                <div class="inBox col2">
                  <label class="checkBox">
                    <input
                      type="radio"
                      v-model="detail.cellClassify"
                      value="1"
                    />
                    <span>未见上皮内病变或恶性病变</span>
                  </label>
                  <label class="checkBox">
                    <input
                      type="radio"
                      v-model="detail.cellClassify"
                      value="2"
                    />
                    <span>非典型鳞状上皮细胞</span>
                  </label>
                  <label class="checkBox">
                    <input
                      type="radio"
                      v-model="detail.cellClassify"
                      value="3"
                    />
                    <span>非典型腺细胞</span>
                  </label>
                  <label class="checkBox">
                    <input
                      type="radio"
                      v-model="detail.cellClassify"
                      value="4"
                    />
                    <span>低度鳞状上皮内病变</span>
                  </label>
                  <label class="checkBox">
                    <input
                      type="radio"
                      v-model="detail.cellClassify"
                      value="5"
                    />
                    <span>可疑腺癌</span>
                  </label>
                  <label class="checkBox">
                    <input
                      type="radio"
                      v-model="detail.cellClassify"
                      value="6"
                    />
                    <span>高度鳞状上皮内病变</span>
                  </label>
                  <label class="checkBox">
                    <input
                      type="radio"
                      v-model="detail.cellClassify"
                      value="7"
                    />
                    <span>腺癌</span>
                  </label>
                  <label class="checkBox">
                    <input
                      type="radio"
                      v-model="detail.cellClassify"
                      value="8"
                    />
                    <span>鳞状细胞</span>
                  </label>
                  <label class="checkBox">
                    <input
                      type="radio"
                      v-model="detail.cellClassify"
                      value="0"
                    />
                    <span>无</span>
                  </label>
                </div>
              </dd>
            </dl>
            <dl>
              <dt>微生物分析：</dt>
              <dd>
                <div class="inBox col3">
                  <label class="checkBox">
                    <input
                      type="checkbox"
                      v-model="detail.micClassify"
                      value="1"
                    />
                    <span>滴虫感染</span>
                  </label>

                  <label class="checkBox">
                    <input
                      type="checkbox"
                      v-model="detail.micClassify"
                      value="2"
                    />
                    <span>念珠菌感染</span>
                  </label>
                  <label class="checkBox">
                    <input
                      type="checkbox"
                      v-model="detail.micClassify"
                      value="3"
                    />
                    <span>细菌过渡增生</span>
                  </label>
                  <label class="checkBox">
                    <input
                      type="checkbox"
                      v-model="detail.micClassify"
                      value="4"
                    />
                    <span>疱疹病毒感染</span>
                  </label>
                  <label class="checkBox">
                    <input
                      type="checkbox"
                      v-model="detail.micClassify"
                      value="5"
                    />
                    <span>HPV感染</span>
                  </label>
                </div>
              </dd>
            </dl>
            <dl>
              <dt>炎症：</dt>
              <dd>
                <div class="inBox col3">
                  <label class="checkBox">
                    <input
                      type="radio"
                      v-model="detail.degreeOfInfla"
                      value="1"
                    />
                    <span>轻度</span>
                  </label>
                  <label class="checkBox">
                    <input
                      type="radio"
                      v-model="detail.degreeOfInfla"
                      value="2"
                    />
                    <span>中度</span>
                  </label>
                  <label class="checkBox">
                    <input
                      type="radio"
                      v-model="detail.degreeOfInfla"
                      value="3"
                    />
                    <span>高度</span>
                  </label>
                </div>
              </dd>
            </dl>
            <dl>
              <dt>炎细胞覆盖率：</dt>
              <dd>
                <div class="inBox col3">
                  <label class="checkBox">
                    <input
                      type="radio"
                      v-model="detail.coverageClassify"
                      value="1"
                    />
                    <span>少于50%</span>
                  </label>
                  <label class="checkBox">
                    <input
                      type="radio"
                      v-model="detail.coverageClassify"
                      value="2"
                    />
                    <span>50%-75%</span>
                  </label>
                  <label class="checkBox">
                    <input
                      type="radio"
                      v-model="detail.coverageClassify"
                      value="3"
                    />
                    <span>多余75%</span>
                  </label>
                </div>
              </dd>
            </dl>
          </div>

          <div class="img">
            <p>镜下所见</p>
            <img :src="detail.watchPng" />
          </div>
        </div>
        <dl class="msg">
          <dt>判读意见：</dt>
          <dd>
            <textarea
              placeholder="请输入..."
              v-model="detail.suggest"
            ></textarea>
          </dd>
        </dl>
        <div class="reportResult">
          <div class="inBox">
            <span>报告医师：</span>
            <p>{{ detail.reportPerson }}</p>
          </div>
          <div class="inBox">
            <span>报告日期：</span>
            <p>{{ detail.reportDate }}</p>
          </div>
        </div>
        <div class="btnBox">
          <a @click="save">保存</a>
          <a @click="sea">预览</a>
          <a @click="sea">打印</a>
          <a @click="outPour">导出</a>
        </div>
      </div>
    </div>
    <foot-page></foot-page>
  </div>
</template>

<style lang="scss" scoped>
@import "./report.scss";
</style>

<script>
import headPage from "../../components/Head/head";
import footPage from "../../components/footer/foot";
export default {
  data() {
    return {
      userId: "",
      studyId: "",
      detail: {},
    };
  },
  components: {
    headPage,
    footPage,
  },
  created() {
    let that = this;
    that.userId = JSON.parse(sessionStorage.getItem("userData")).id;
    that.studyId = JSON.parse(this.$route.query.studyId);
  },
  mounted() {
    let that = this;
    that.getReport();
  },
  methods: {
    isSatisfied() {
      let that = this;
      let { detail } = that;
      if (detail.isSatisfied == 1) {
        that.detail.satisfiedDescription = [];
      }
    },
    goReport() {
      let that = this;
      that.$router.replace({
        name: "Report",
      });
    },
    getReport() {
      let that = this;
      let param = new Object();
      param.userId = that.userId;
      param.studyId = that.studyId;
      that.ajax.get("report/selectReport", param).then((res) => {
        res.data.satisfiedDescription =
          res.data.satisfiedDescription != null &&
          res.data.satisfiedDescription != ""
            ? res.data.satisfiedDescription.toString().split(",")
            : [];
        res.data.micClassify =
          res.data.micClassify != null
            ? res.data.micClassify.toString().split(",")
            : [];

        that.detail = res.data;
        console.log(that.detail);
      });
    },
    save() {
      let that = this;
      let param = new Object();
      param.userId = that.userId;
      param.studyId = that.studyId;
      param.isSatisfied = that.detail.isSatisfied;
      param.satisfiedDescription =
        param.isSatisfied == 2
          ? that.detail.satisfiedDescription.toString()
          : "";
      param.cellClassify = that.detail.cellClassify.toString();
      param.micClassify = that.detail.micClassify.toString();
      param.degreeOfInfla = that.detail.degreeOfInfla;
      param.coverageClassify = that.detail.coverageClassify;
      param.suggest = that.detail.suggest;

      if (param.isSatisfied == 2 && param.satisfiedDescription == "") {
        that.$toast({
          message: "请选择不满意类型",
          closeOnClick: true,
          closeOnClickOverlay: true,
          forbidClick:true,
          closeOnClickOverlay:true,
        });
        return;
      }

      that.ajax.post("report/saveReport", param).then((res) => {
        that.$toast.success({
          message: "保存成功",
          closeOnClick: true,
          closeOnClickOverlay: true,
          onClose() {
            that.getReport();
          },
        });
        //
      });
    },
    sea() {
      let that = this;
      if (that.detail.id) {
        let { id: reportId } = that.detail;
        window.open(
          that.ajax.baseUrl() + "/report/viewReport?reportId=" + reportId
        );
      } else {
        that.$toast.fail({
          type: "fail",
          message: "请先保存报告",
          duration: 0,
          overlay: true,
          closeOnClickOverlay: true,
          closeOnClick: true,
        });
      }
    },
    print() {},
    outPour() {
      let that = this;
      if (that.detail.id) {
        let { id: reportId } = that.detail;
        window.open(
          that.ajax.baseUrl() + "/report/downReport?reportId=" + reportId
        );
      } else {
        that.$toast.fail({
          type: "fail",
          message: "请先保存报告",
          duration: 0,
          overlay: true,
          closeOnClickOverlay: true,
          closeOnClick: true,
        });
      }
    },
  },
};
</script>
